import { render } from "./CreateOrderView.vue?vue&type=template&id=449d1902"
import script from "./CreateOrderView.vue?vue&type=script&lang=js"
export * from "./CreateOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__